"use strict";

var cov_lxzj1ldgk = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Actions.js";
  var hash = "f6282e33487c0c66700aa3d5ef1359b7b5c57b55";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\Actions.js",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 29
        }
      },
      "1": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 30,
          column: 4
        }
      },
      "2": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 22,
          column: 16
        }
      },
      "3": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      "4": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 43,
          column: 3
        }
      },
      "5": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 54,
          column: 2
        }
      },
      "6": {
        start: {
          line: 56,
          column: 18
        },
        end: {
          line: 62,
          column: 3
        }
      },
      "7": {
        start: {
          line: 56,
          column: 39
        },
        end: {
          line: 62,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "ParallelTitles",
        decl: {
          start: {
            line: 6,
            column: 9
          },
          end: {
            line: 6,
            column: 23
          }
        },
        loc: {
          start: {
            line: 9,
            column: 3
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 31
          },
          end: {
            line: 11,
            column: 32
          }
        },
        loc: {
          start: {
            line: 11,
            column: 74
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 56,
            column: 29
          },
          end: {
            line: 56,
            column: 30
          }
        },
        loc: {
          start: {
            line: 56,
            column: 39
          },
          end: {
            line: 62,
            column: 1
          }
        },
        line: 56
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "f6282e33487c0c66700aa3d5ef1359b7b5c57b55"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function ParallelTitles(_ref) {
  var actions = _ref.actions,
      buttons = _ref.buttons;
  cov_lxzj1ldgk.f[0]++;
  var classes = (cov_lxzj1ldgk.s[0]++, useStyles());

  var _actions = (cov_lxzj1ldgk.s[1]++, actions.map(function (_ref2, index) {
    var icon = _ref2.icon,
        tooltip = _ref2.tooltip,
        onClick = _ref2.onClick,
        menu = _ref2.menu;
    cov_lxzj1ldgk.f[1]++;
    var button = (cov_lxzj1ldgk.s[2]++, _react.default.createElement(_core.Tooltip, {
      title: tooltip,
      arrow: true
    }, _react.default.createElement(_core.IconButton, {
      "aria-label": tooltip,
      onClick: onClick,
      className: classes.action,
      size: "small"
    }, icon)));
    cov_lxzj1ldgk.s[3]++;
    return _react.default.createElement("span", {
      key: index
    }, button, menu);
  }));

  cov_lxzj1ldgk.s[4]++;
  return _react.default.createElement(_core.Grid, {
    container: true,
    direction: "row",
    justify: "flex-end",
    alignItems: "center",
    className: classes.root
  }, _actions, buttons);
}

;
cov_lxzj1ldgk.s[5]++;
ParallelTitles.propTypes = {
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.element.isRequired,
    tooltip: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func
  }).isRequired)
};
var useStyles = (cov_lxzj1ldgk.s[6]++, (0, _styles.makeStyles)(function (theme) {
  cov_lxzj1ldgk.f[2]++;
  cov_lxzj1ldgk.s[7]++;
  return {
    root: {},
    action: {
      padding: '8px'
    }
  };
}));
var _default = ParallelTitles;
exports.default = _default;